<template>
    <div>
        <div class="title-chat">{{ etiqueta }}</div>
        <div class="chat-container">
            <div class="chat-box">
                <div class="messages">
                    <div 
                        v-for="(message, index) in formattedMessages"
                        :key="index" 
                        :class="{
                            'usuario_message': message.user === 'Usuario', 
                            'bot_message': message.user === 'Bot'
                        }"
                        class="message"
                    >
                        <strong>{{ message.user }}:</strong> {{ message.text }}
                    </div>
                </div>

                <div class="input-container">
                    <input
                        v-model="new_message"
                        @keyup.enter="send_message($event)"
                        type="text"
                        class="message-input"
                        placeholder="Escribe tu mensaje..."
                    />
                    <button @click="send_message" class="send-button">Enviar</button>
                </div>

                <textarea v-model="last_bot_response" placeholder="Manifiesto Area"></textarea>
            
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        
        name: 'OpenAI',

        props: ['etiqueta', 'initial_conversation', 'url_auth', 'username', 'password', 'url_open_ai', 'field', 'formValues'],

        data() {
            return {
                new_message: "",
                token_used_to_query_gpt: "",
                id_user: "",
                id_conversation: "",
                last_bot_response: "",
                history: { id_conversation: "", history: "", value: "" }
            };
        },

        computed: {
            formattedMessages() {
                const messagesArray = this.history.history.split("\n").filter(msg => msg.trim() !== "");
                return messagesArray.map(msg => {
                    const [user, ...text] = msg.split(": ");
                    return { user: user.trim(), text: text.join(": ").trim() };
                });
            }
        },

        watch: {
            history: {
                handler(newHistory, oldHistory) {
                    console.log("History ha cambiado:", newHistory, oldHistory);
                    this.field.value = JSON.stringify(this.history);
                    this.formValues[this.field.nombre] = this.field.value;
                    console.log("Este es el nuevo this.field.value: ", this.field.value)
                },
                deep: true
            },
            last_bot_response(newResponseBot, oldResponseBot) {
                this.history.value = newResponseBot
                console.log(`Respuesta bot cambió de: "${oldResponseBot}" a: "${newResponseBot}"`);
            }//Agregue esto, cuando cambie el valor de last_bot_response... agregar ese nuevo valor al campo value del history 
        },

        mounted() {
            if (this.initial_conversation == "" || this.initial_conversation == null || this.field.value == null || this.field.value == "") {
                this.history.history = "Usuario: Hola!\n";
                this.query_open_ai('Hola!', "");
            } 
            else {
                if ((this.field.value && this.initial_conversation) || (this.field.value && !this.initial_conversation)) {
                    const parsedHistory = this.field.value//JSON.parse(this.field.value);
                    this.history.history = parsedHistory.history;
                    this.id_conversation = parsedHistory.id_conversation;
                    this.last_bot_response = parsedHistory.value;
                    this.history.value = parsedHistory.value //Agregue esto para que no se resetie el value
                }
                if (this.initial_conversation && !this.field.value) {
                    this.history.history = `Usuario: ${this.initial_conversation}\n`;
                    this.query_open_ai(this.initial_conversation, "");
                }
            }
        },

        methods: {
            send_message(event) {
                event.preventDefault();
                if (this.new_message.trim() !== "") {
                    if (this.history.history) {
                        this.history.history += `Usuario: ${this.new_message}\n`;
                    } else {
                        this.history.history = `Usuario: ${this.new_message}\n`;
                    }
                    this.query_open_ai(this.new_message, this.id_conversation);
                    this.new_message = "";
                }
            },

            async auth() {
                const credentials = `${this.username}:${this.password}`;
                const base64Credentials = btoa(credentials);

                const headers = {
                    "Content-Type": "application/json",
                    "Authorization": `Basic ${base64Credentials}`
                };

                await axios.post(this.url_auth, {}, { headers })
                    .then(response => {
                        this.token_used_to_query_gpt = response.data.token;
                        this.id_user = response.data.userId;
                    })
                    .catch(error => {
                        console.log("Error en la autenticación", error);
                    });
            },

            async query_open_ai(message, id_conversation) {
                await this.auth();

                const headers = {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${this.token_used_to_query_gpt}`
                };

                await axios.post(this.url_open_ai, { user_query: message, id_conversation, id_user: this.id_user }, { headers })
                    .then(response => {
                        if (this.history.history) {
                            this.history.history += `Bot: ${response.data.bot_response}\n`;
                        } else {
                            this.history.history = `Bot: ${response.data.bot_response}\n`;
                        }

                        this.last_bot_response = response.data.bot_response;
                        this.history.value = this.last_bot_response;
                        this.id_conversation = response.data.id_conversation;
                        this.history.id_conversation = this.id_conversation;
                    })
                    .catch(error => {
                        console.log("Error al hacer consulta a GPT", error);
                    });
            }
        }
    };
</script>

<style scoped>
    .title-chat{
        text-align: center;
        font-weight: 600;
        margin-bottom: 0.5rem;
    }

    .chat-container {
        width: 100%;
        max-width: 600px;
        height: 700px;
        background-color: #f1f1f1;
        border-radius: 0.75rem;
    }
    
    .chat-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    
    .messages {
        margin-bottom: 10px;
        overflow-y: auto;
        height: 70%;
    }

    .message {
        padding: 1rem;
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
        word-wrap: break-word;
    }

    .usuario_message {
        width: fit-content;
        max-width: 80%;
        background-color: rgb(250, 250, 250);
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
        margin-left: auto; 
    }

    .bot_message {
        width: fit-content;
        max-width: 80%;
        background-color: #fcfcfc;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        margin-right: auto; 
    }

    .message strong {
        color: #411212;
    }

    .input-container {
        height: 5%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.8rem;
        padding: 1rem;
    }

    .message-input {
        width: 88%;
        padding: 1rem;
        font-size: 0.8rem;
        border-radius: 5px;
        outline: none;
        background-color: rgb(223, 223, 223);
    }

    .send-button {
        background-color: #360808;
        color: white;
        border: none;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    textarea {
        height: 20%;
        margin: 1rem;
        padding: 1rem;
        font-size: 0.8rem;
        color: #555555;
        outline: none;
        resize: none;
        background-color: #f7f7f7;
        border-radius: 1rem;
    }
</style>